{
  "page": {
    "title": "Shipping",
    "subtitle": "Manage shipping fees, carrier rate cards, providers & carriers, weight bands, delivery methods, margin reporting and change history."
  },
  "price": {
    "title": "Shipping Price List",
    "subtitle": "Manage prices by Service (not by Carrier).",
    "manageServices": "Manage Services",
    "downloadTemplate": "Download Template",
    "export": "Export",
    "importExcel": "Import Excel",
    "addRateTable": "Add Rate Table"
  },
  "rateTable": {
    "title": "Carrier Rate Table",
    "subtitle": "Rate by zone by provider by service.",
    "accessDenied": {
      "title": "Access denied",
      "body": "You do not have permission to view cost data (VIEW_FINANCIAL_COST). Contact an administrator if you need access."
    }
  },
  "rateTable2": {
    "page": {
      "title": "Shipping Rate Table — Master-Detail",
      "subtitle": "Manage rates per carrier · cross-provider comparison",
      "legacyLink": "View legacy UI"
    },
    "tabs": {
      "rate": "Rates",
      "routing": "Routing",
      "margin": "Margin Report",
      "history": "History"
    },
    "band": {
      "label": "Compare all carriers",
      "sub": "Find the cheapest rate across every provider · LeastCost"
    },
    "panel": {
      "title": "Carriers",
      "inactiveBadge": "Inactive",
      "meta": "{{carrierCount}} carriers · {{zoneCount}} zones"
    },
    "matrix": {
      "viewDomestic": "Domestic",
      "viewInbound": "Inbound",
      "addRate": "Add rate",
      "importCsv": "Import CSV"
    },
    "empty": {
      "domestic": "This provider has no Domestic rate card yet",
      "inbound": "This provider has no Inbound rate card yet",
      "switchHint": "Try switching to the other view"
    },
    "readonly": {
      "banner": "Carrier is no longer in service — read-only"
    },
    "navigation": {
      "rt2Routing": "Routing",
      "rt2Margin": "Margin Report",
      "rt2History": "History",
      "rt2Rate": "Rates"
    },
    "bulk": {
      "bar": "Bulk edit price",
      "editPrice": "Edit price",
      "selectAll": "Select all",
      "applyTo": "Apply to",
      "newPrice": "New price",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "selectedCount": "{{count}} selected",
      "noTargets": "No rate cells to update for this selection.",
      "queued": "Sent {{count}} requests for approval (two-step workflow)."
    }
  },
  "tabs": {
    "fee": "Fee",
    "rate": "Rate",
    "routing": "Routing",
    "providers": "Providers & Carriers",
    "weightBands": "Weight Bands",
    "methods": "Methods",
    "margin": "Margin Report",
    "history": "History"
  },
  "placeholder": {
    "comingSoon": "Coming soon",
    "wave7": "This tab's content lands in the next delivery wave."
  },
  "states": {
    "loading": "Loading…",
    "empty": "No data yet.",
    "emptyCta": "Get started by adding your first record.",
    "errorTitle": "Failed to load data",
    "retry": "Retry"
  },
  "approval": {
    "queued": "Change request submitted",
    "queuedFor": "Change queued for approval (dual-approval workflow)."
  },
  "fee": {
    "title": "Shipping fee",
    "subtitle": "Manage charged fees by destination, method and weight band.",
    "countries": "Countries",
    "zip3Count": "{{count}} ZIP3 codes",
    "selectCountryPrompt": "Select a country to view per-ZIP fee detail.",
    "zip3Grid": "ZIP3 fee grid — {{country}}",
    "zip5Exceptions": "ZIP5 exceptions",
    "noZip3": "No ZIP3 fees for this country yet.",
    "noZip5": "No ZIP5 exceptions yet.",
    "baseFee": "Base fee (cents)",
    "additionalItemFee": "Additional item fee (cents)",
    "save": "Save",
    "editReason": "Fee update from the shipping fee table",
    "confirmNegativeMargin": "Confirm despite negative margin",
    "pending": "Pending approval",
    "importCsv": "Import CSV",
    "importTitle": "Import shipping fees from CSV"
  },
  "csv": {
    "fileLabel": "CSV file",
    "hint": "Pick a CSV file to preview before submitting for approval.",
    "dryRun": "Preview",
    "dryRunning": "Previewing…",
    "commit": "Submit for approval",
    "committing": "Submitting…",
    "close": "Close",
    "summary": "{{total}} rows total — {{ok}} valid, {{errors}} errors.",
    "colRow": "Row",
    "colStatus": "Status",
    "colErrors": "Errors",
    "statusOk": "Valid",
    "statusError": "Error",
    "queuedSummary": "Submitted {{count}} rows for approval.",
    "deduped": "(Request already existed — deduplicated.)"
  },
  "deprecate": {
    "title": "Shipping rate configuration has moved to the new Shipping page",
    "body": "This tab (v1) is being retired. Please use the new Carrier Rate Table page to manage shipping costs and rate cards.",
    "cta": "Open the new Rate Table page"
  },
  "providers": {
    "filter": {
      "searchPlaceholder": "Search by name or code",
      "showDeleted": "Show deleted"
    },
    "col": {
      "name": "Name",
      "code": "Code",
      "agency": "Agency",
      "credential": "Credential",
      "adapter": "Live-rate adapter",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "deleted": "Deleted"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete",
      "restore": "Restore"
    },
    "agencies": {
      "title": "Agencies",
      "subtitle": "Top of the Agency → Provider → Carrier tree.",
      "create": "Add agency",
      "createTitle": "Add agency",
      "editTitle": "Edit agency"
    },
    "providers": {
      "title": "Providers",
      "subtitle": "API credential is write-only — only set/unset status is shown.",
      "create": "Add provider",
      "createTitle": "Add provider",
      "editTitle": "Edit provider",
      "needAgency": "Create an agency first before adding a provider."
    },
    "carriers": {
      "title": "Carriers",
      "subtitle": "Data-driven registry — add a carrier without a code change.",
      "create": "Add carrier",
      "createTitle": "Add carrier",
      "editTitle": "Edit carrier",
      "adapterYes": "Yes",
      "adapterNo": "No"
    },
    "credential": {
      "label": "API credential (write-only)",
      "statusSet": "Set",
      "statusUnset": "Not set",
      "placeholderSet": "Enter a new credential secret",
      "placeholderRotate": "Enter a new secret to rotate",
      "help": "The secret is never displayed again after saving. Leave blank to keep the current credential.",
      "clear": "Clear the stored credential"
    },
    "matrix": {
      "title": "Provider–Carrier enablement",
      "subtitle": "Enable a carrier under a provider for new-order pricing. Disabling does not re-route committed orders.",
      "providerCol": "Provider",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "noLink": "no link",
      "empty": "Add providers and carriers to manage their enablement."
    },
    "form": {
      "name": "Name",
      "code": "Code",
      "agency": "Agency",
      "agencyPlaceholder": "Select an agency",
      "status": "Status",
      "save": "Save",
      "saving": "Saving…",
      "cancel": "Cancel",
      "errName": "Name is required.",
      "errCode": "Code must be 2–40 chars: A–Z, 0–9, _ or -.",
      "errAgency": "Select an agency."
    },
    "confirm": {
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "This is a soft-delete — the record can be restored. If it is still referenced, deletion is blocked.",
      "deleteConfirm": "Delete",
      "cancel": "Cancel"
    },
    "toast": {
      "saved": "Saved",
      "saveFailed": "Could not save",
      "deleted": "Deleted",
      "deleteFailed": "Could not delete",
      "restored": "Restored",
      "restoreFailed": "Could not restore",
      "toggleSaved": "Enablement updated",
      "toggleFailed": "Could not update enablement"
    }
  },
  "rate": {
    "matrix": {
      "weightColumn": "Weight",
      "gramColumn": "Gram (g)",
      "zoneHeader": "Zone {{n}}",
      "emptyCell": "—",
      "empty": "No rate cards for this provider yet.",
      "providerFilter": {
        "label": "Filter by provider",
        "all": "All providers",
        "selectAll": "Select all",
        "deselectAll": "Deselect all"
      },
      "viewSwitch": {
        "domestic": "US Domestic",
        "inbound": "US Inbound"
      },
      "inbound": {
        "priceColumn": "Flat price"
      },
      "invalidRate": "Rate must be a non-negative number.",
      "changeReason": "Update route cost from the rate table.",
      "editTitle": "Rate change request",
      "rateCents": "Rate (cents)",
      "cancel": "Cancel",
      "submitRequest": "Submit request",
      "weightCol": "Weight",
      "gramCol": "Grams (g)",
      "providerHeader": "Provider",
      "zoneLabel": "Zone {{n}}",
      "filter": {
        "label": "Filter providers",
        "all": "All"
      },
      "view": {
        "label": "Rate table view mode",
        "domestic": "US Domestic",
        "inbound": "US Inbound"
      },
      "meta": "Rate matrix by weight × zone · USD"
    },
    "override": {
      "pinned": "Route pinned.",
      "unpinned": "Route unpinned.",
      "title": "Pin route (priority override)",
      "provider": "Provider",
      "selectOption": "— Select —",
      "destType": "Destination type",
      "destKey": "Destination key",
      "destPlaceholder": "ZIP / country / zone",
      "method": "Method",
      "band": "Weight band",
      "reason": "Pin reason",
      "reasonPlaceholder": "Why pin this provider for the route?",
      "pin": "Pin provider",
      "selectFirst": "Select a provider to pin.",
      "empty": "No pinned routes yet.",
      "unpin": "Unpin"
    },
    "noAccess": "You do not have permission to view cost data.",
    "import": "Import CSV",
    "pending": {
      "badge": "Pending approval"
    },
    "preview": {
      "errDest": "Enter a destination (ZIP/country).",
      "errWeight": "Weight must be a positive number of grams.",
      "errMethod": "Select a delivery method.",
      "missingRoute": "No matching route for this destination and weight.",
      "title": "Least-cost preview",
      "destination": "Destination",
      "weight": "Weight (g)",
      "method": "Method",
      "methodAny": "— Select —",
      "run": "View cost",
      "cheapest": "Cheapest",
      "pinned": "Pinned"
    },
    "providerTab": {
      "empty": "This provider has no rate cards yet.",
      "label": "Select a shipping provider"
    },
    "serviceBlock": {
      "heading": "Service: {{name}}"
    }
  },
  "errors": {
    "loadFee": "Failed to load shipping fee tables.",
    "loadRate": "Failed to load carrier rate cards.",
    "loadProviders": "Failed to load providers.",
    "loadCarriers": "Failed to load carriers.",
    "loadProviderCarriers": "Failed to load provider-carrier links.",
    "loadAgencies": "Failed to load agencies.",
    "loadWeightBands": "Failed to load weight bands.",
    "loadMethods": "Failed to load delivery methods.",
    "loadMethodServiceMaps": "Failed to load service maps.",
    "loadRouteOverrides": "Failed to load route overrides.",
    "loadMarginReport": "Failed to load margin report.",
    "ratePreview": "Failed to fetch the cost preview.",
    "import": "Failed to process the import file.",
    "network": "Network error - check connection"
  },
  "ratesTab": {
    "toast": {
      "saved": "Saved the rate table for {{name}}",
      "saveFailed": "Could not save the rate table for {{name}}"
    },
    "saving": "Saving…",
    "loadError": "Could not load shipping rates.",
    "retry": "Try again",
    "empty": "No shipping categories yet.",
    "intro": "Each shipping category manages a 7 zones × 2 speed tiers matrix (14 cells total). Click a row to open/close the inline matrix.",
    "reasonLabel": "Reason for change (≥10 characters, required)"
  },
  "configProvider": {
    "title": "Provider",
    "subtitle": "Manage agencies, providers and the Provider–Carrier enable toggles. The API credential is write-only and is never displayed back.",
    "agencyTitle": "Agency",
    "agencySubtitle": "An agency is the parent of a Provider.",
    "providerTitle": "Provider",
    "providerSubtitle": "A provider belongs to an agency; its credential is write-only.",
    "matrixTitle": "Provider – Carrier toggles",
    "matrixSubtitle": "Enable/disable each Provider–Carrier pair to route rate quotes.",
    "matrixEmpty": "At least one provider and one carrier are required.",
    "matrixProviderCol": "Provider",
    "matrixEnabled": "Enabled",
    "matrixDisabled": "Disabled",
    "matrixNoLink": "(no link)",
    "addAgency": "Add agency",
    "addProvider": "Add provider",
    "needAgency": "Create an agency before adding a provider.",
    "edit": "Edit",
    "restore": "Restore",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "saving": "Saving…",
    "colName": "Name",
    "colCode": "Code",
    "colAgency": "Agency",
    "colCredential": "Credential",
    "colStatus": "Status",
    "colActions": "Actions",
    "name": "Name",
    "code": "Code",
    "agency": "Agency",
    "agencyPlaceholder": "Select an agency",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "statusDeleted": "Deleted",
    "credentialSet": "Set",
    "credentialUnset": "Unset",
    "agencyCreateTitle": "Create agency",
    "agencyEditTitle": "Edit agency",
    "providerCreateTitle": "Create provider",
    "providerEditTitle": "Edit provider",
    "deleteAgencyTitle": "Delete agency",
    "deleteProviderTitle": "Delete provider",
    "deleteConfirm": "Delete this record? A referenced record cannot be deleted.",
    "errName": "Name is required.",
    "errCode": "Code must be 2–40 chars of A–Z, 0–9, _ or -.",
    "errAgency": "Please select an agency.",
    "saved": "Saved",
    "restored": "Restored",
    "deletedToast": "Deleted",
    "toggleSaved": "Toggle saved",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "fkRestrict": "Cannot delete: record is referenced."
  },
  "routes": {
    "title": "Shipping Routes",
    "subtitle": "Manage international and domestic delivery routes",
    "add": "+ Add Route",
    "searchPlaceholder": "Search by code, name…",
    "filterTypeAll": "All types",
    "filterOriginAll": "All origins",
    "filterDestinationAll": "All destinations",
    "colRoute": "ROUTE",
    "colType": "TYPE",
    "colCarrier": "CARRIER",
    "colServiceArea": "SERVICE AREA",
    "colEstDays": "EST. DAYS",
    "colBaseFee": "BASE FEE",
    "colXBorder": "X-BORDER",
    "colStatus": "STATUS",
    "colActions": "ACTIONS",
    "empty": "No shipping routes yet",
    "total": "Total: {{count}}",
    "show": "Show:",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save route config",
    "create": "Create route",
    "createTitle": "Shipping route config",
    "editTitle": "Edit route config",
    "deleteTitle": "Delete route config",
    "deleteConfirm": "Delete this routing config? A route with no split config falls back to least-cost.",
    "destinationType": "Destination type",
    "destinationKey": "Destination key",
    "methodId": "Service (method)",
    "weightBandId": "Weight band",
    "destType": {
      "us_zip5": "US ZIP5",
      "us_zip3": "US ZIP3",
      "country": "Country",
      "zone": "Zone"
    },
    "saved": "Routing config saved",
    "deletedToast": "Route config deleted",
    "duplicate": "This route already has an active routing config.",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "invalidWeights": "The weights must sum to 100.",
    "inactiveProvider": "Inactive provider — cannot be allocated.",
    "forbidden": "You lack the VIEW_FINANCIAL_COST permission.",
    "split": {
      "title": "Percent split by provider",
      "subtitle": "Enter a % for each active provider. The weights must sum to 100.",
      "sumLabel": "Total",
      "sumOk": "Total = 100 ✓",
      "sumInvalid": "Total must equal 100 (now {{sum}})",
      "noActive": "No active ProviderCarrier yet — a percent split cannot be configured.",
      "weightSuffix": "%",
      "autoTitle": "Auto-scored weights (read-only)",
      "autoSubtitle": "Weights are derived from the provider score; the admin cannot edit them directly.",
      "autoStubNote": "TODO(M1-stub): the scoring pipeline is not ready yet — using even default weights.",
      "derivedSuffix": "% (auto-scored)"
    },
    "mode": {
      "label": "Routing mode",
      "least_cost": "Least cost",
      "percent_split": "Percent split",
      "auto_score": "Auto score",
      "leastCostHint": "Default: pick the cheapest provider when a route has no split config.",
      "percentSplitHint": "Split traffic by % across active providers; the weights must sum to 100.",
      "autoScoreHint": "Weights are derived automatically from the provider score (SLA/error/CS) — read-only.",
      "pinOverrideNote": "Note: a pinned route (pin-override) wins over ALL routing modes. With no split config, the router falls back to least-cost."
    }
  },
  "zone": {
    "title": "Zone",
    "subtitle": "Manage zones by warehouse/factory location for last-mile pricing. A created zone appears in the last-mile price lookup.",
    "add": "Add zone",
    "edit": "Edit",
    "restore": "Restore",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create zone",
    "createTitle": "Create zone",
    "editTitle": "Edit zone",
    "deleteTitle": "Delete zone",
    "deleteConfirm": "Delete this zone? A zone referenced by fee/rate tables cannot be deleted.",
    "colZone": "Zone",
    "colWarehouse": "Warehouse",
    "colFactory": "Factory",
    "colLastMile": "Last-mile",
    "colStatus": "Status",
    "colActions": "Actions",
    "zoneKey": "Zone key",
    "zoneKeyHint": "Up to 40 chars, unique.",
    "warehouseLocationKey": "Warehouse location (origin)",
    "factoryLocationKey": "Factory location (optional)",
    "carrierHint": "Carrier hint (optional)",
    "lastMileEnabled": "Enable last-mile",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "statusDeleted": "Deleted",
    "lastMileOn": "On",
    "lastMileOff": "Off",
    "none": "—",
    "saved": "Zone saved",
    "restored": "Zone restored",
    "deletedToast": "Zone deleted",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "duplicate": "Zone key already exists — cannot create a duplicate.",
    "fkRestrict": "Cannot delete: zone is referenced by fee/rate tables.",
    "errorValidation": "Invalid data."
  },
  "configCarrier": {
    "title": "Carrier",
    "subtitle": "Manage the carrier registry (USPS/UPS/FedEx…). Carriers with an adapter support automated rate quotes.",
    "add": "Add carrier",
    "edit": "Edit",
    "restore": "Restore",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create carrier",
    "createTitle": "Create carrier",
    "editTitle": "Edit carrier",
    "deleteTitle": "Delete carrier",
    "deleteConfirm": "Delete this carrier? A referenced carrier cannot be deleted.",
    "colName": "Name",
    "colCode": "Code",
    "colAdapter": "Adapter",
    "colStatus": "Status",
    "colActions": "Actions",
    "name": "Name",
    "code": "Code",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "statusDeleted": "Deleted",
    "adapterYes": "Has adapter",
    "adapterNo": "No adapter",
    "errName": "Name is required.",
    "errCode": "Code must be 2–40 chars of A–Z, 0–9, _ or -.",
    "saved": "Carrier saved",
    "restored": "Carrier restored",
    "deletedToast": "Carrier deleted",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "fkRestrict": "Cannot delete: carrier is referenced."
  },
  "dutyRate": {
    "title": "Duty Rate",
    "subtitle": "Configure import duty per zone (applies to non-US vendor orders shipping to the US). DDP: platform charges duty; DDU: buyer pays at customs.",
    "colZone": "Zone",
    "colPercent": "Duty rate (%)",
    "colPayer": "Duty payer",
    "colMultiplier": "Customs multiplier",
    "colActions": "Actions",
    "percent": "Import duty rate (%)",
    "percentHint": "Between 0 and 100.",
    "payer": "Duty payer",
    "payerDDP": "DDP (Delivered Duty Paid)",
    "payerDDU": "DDU (Delivered Duty Unpaid)",
    "multiplier": "Customs multiplier (optional)",
    "multiplierHint": "Leave blank = keep current value.",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "unset": "Not configured",
    "saved": "Duty rate saved",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "forbidden": "You do not have permission to view/edit import duty (cost surface).",
    "errorRange": "Duty rate must be between 0 and 100.",
    "errorValidation": "Invalid data."
  },
  "methods": {
    "title": "Delivery Methods",
    "subtitle": "Create a method (always draft), then add at least one service map before activating it.",
    "add": "Add method",
    "name": "Name",
    "code": "Code (A-Z, 0-9, _ -)",
    "colName": "Name",
    "colCode": "Code",
    "colStatus": "Status",
    "colMaps": "Service maps",
    "colActions": "Actions",
    "statusDraft": "Draft",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "deleted": "Deleted",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "delete": "Delete",
    "restore": "Restore",
    "manageMaps": "Service maps",
    "addServiceMap": "Add service map",
    "providerCarrier": "Provider · Carrier",
    "serviceCode": "Service code (e.g. usps_priority)",
    "noMaps": "No service maps yet. Add at least one to activate the method.",
    "mapsCount": "{{count}} service maps",
    "saved": "Method saved",
    "activated": "Method activated",
    "deactivated": "Method deactivated",
    "deletedToast": "Method deleted",
    "restored": "Method restored",
    "mapSaved": "Service map saved",
    "mapDeleted": "Service map deleted",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "activateNeedsMap": "Method needs at least one service map to activate.",
    "lastMapGuard": "Cannot remove the only service map of an active method.",
    "duplicateMap": "This service map already exists.",
    "loadMapsError": "Failed to load service maps."
  },
  "weightBands": {
    "title": "Weight Bands",
    "subtitle": "Half-open [min, max) intervals in grams — min inclusive, max exclusive. The top band is unbounded (leave max blank).",
    "add": "Add band",
    "edit": "Edit",
    "restore": "Restore",
    "delete": "Delete",
    "colInterval": "Interval",
    "colLabel": "Label",
    "colStatus": "Status",
    "colActions": "Actions",
    "minGrams": "Min (grams, inclusive)",
    "maxGrams": "Max (grams, exclusive)",
    "maxGramsHint": "Leave blank = unbounded (top band).",
    "label": "Label",
    "unbounded": "Unbounded",
    "deleted": "Deleted",
    "saved": "Weight band saved",
    "restored": "Weight band restored",
    "deletedToast": "Weight band deleted",
    "staleVersion": "This record changed elsewhere — reloaded, please try again.",
    "cancel": "Cancel",
    "save": "Save",
    "errorOverlap": "Weight bands overlap.",
    "errorGap": "Weight bands leave an uncovered gap.",
    "errorNoUnbounded": "Exactly one unbounded top band (blank max) is required.",
    "errorValidation": "Max must be greater than min (half-open [min, max))."
  },
  "history": {
    "heading": "Shipping rate / fee change history",
    "subtitle": "Effective-dated change log for rate cards and fee tables (old → new), with the requester and approver (dual-approval workflow).",
    "empty": "No shipping rate / fee changes yet.",
    "error": "Failed to load change history.",
    "view": "View detail",
    "col": {
      "effectiveFrom": "Effective from",
      "target": "Target",
      "newValue": "New value",
      "status": "Status",
      "requestedBy": "Requested by",
      "approvedBy": "Approved by"
    },
    "target": {
      "rateCard": "Carrier rate card",
      "feeTable": "Fee table"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "detail": {
      "title": "Change detail",
      "close": "Close",
      "supersedes": "Supersedes row",
      "netNew": "Net-new (no supersede)",
      "decidedAt": "Decided at",
      "costRedacted": "Some cost fields are hidden because you lack cost visibility."
    }
  },
  "margin": {
    "heading": "Per-route margin report",
    "subtitle": "Margin per route = Fee − actual carrier cost (falls back to the estimate before a label is bought).",
    "forbidden": "You do not have permission to view cost data (VIEW_FINANCIAL_COST).",
    "filterRoute": "Filter by route type",
    "filterAll": "All routes",
    "empty": "No routes with real cost yet to show a margin.",
    "estimateBadge": "(estimate)",
    "estimateFallback": "No label bought yet — using the estimated cost.",
    "varianceExceeded": "Exceeded",
    "varianceOk": "Within threshold",
    "destinationType": {
      "us_zip5": "US ZIP-5",
      "us_zip3": "US ZIP-3",
      "country": "Country",
      "zone": "Zone"
    },
    "col": {
      "route": "Route",
      "fee": "Fee",
      "actualRate": "Actual cost",
      "margin": "Margin",
      "variance": "Variance",
      "flag": "Flag"
    }
  },
  "config": {
    "title": "Shipping Configuration",
    "subtitle": "Manage zones, carriers, services, shipping routes, import duty, providers and weight bands.",
    "tabs": {
      "zone": "Zone",
      "carrier": "Carrier",
      "service": "Service",
      "shippingRoutes": "Shipping Routes",
      "dutyRate": "Duty Rate",
      "provider": "Provider",
      "weightBands": "Weight Bands"
    },
    "service": {
      "title": "Shipping Services",
      "subtitle": "Manage shipping services (independent of Carrier).",
      "rateTables": "Rate Tables",
      "addService": "+ Add Service"
    },
    "comingSoon": "Coming soon",
    "comingSoonHint": "This tab's content lands in the next delivery wave."
  },
  "trackRouting": {
    "title": "Track Routing",
    "subtitle": "Monitor SLA performance and track all shipments",
    "dashboardTitle": "SLA Performance Dashboard",
    "cards": {
      "on_time_rate": {
        "label": "On-Time Delivery Rate",
        "sub": "{{numerator}} / {{denominator}} shipments"
      },
      "avg_delivery_days": {
        "label": "Avg. Delivery Time",
        "sub": "From shipment to delivery"
      },
      "delayed": {
        "label": "Delayed",
        "sub": "Past estimated delivery"
      },
      "exceptions": {
        "label": "Exceptions",
        "sub": "Require attention"
      },
      "active_time": {
        "label": "Active Time",
        "sub": "{{count}} shipments · avg {{avgHrs}} · max {{maxHrs}}"
      },
      "last_mile_time": {
        "label": "Last-Mile Time",
        "sub": "{{count}} shipments · avg {{avgHrs}} · max {{maxHrs}}"
      }
    },
    "statusOverview": {
      "title": "Shipment Status Overview",
      "delivered": "Delivered",
      "inTransit": "In Transit",
      "pendingPickup": "Pending Pickup",
      "delayed": "Delayed",
      "exceptions": "Exceptions"
    },
    "alerts": {
      "title": "Shipment Alerts",
      "summary": "{{critical}} critical, {{warnings}} warnings",
      "empty": "No alerts.",
      "collapse": "Collapse alerts",
      "expand": "Expand alerts",
      "ageDays": "+{{count}} days",
      "view": "View",
      "openExternal": "Open tracking link",
      "kind": {
        "exception": "Exception",
        "sla_at_risk": "SLA At Risk",
        "delayed": "Delayed"
      }
    },
    "tabs": {
      "all": "All",
      "in_transit": "In Transit",
      "delivered": "Delivered",
      "delayed": "Delayed",
      "exceptions": "Exceptions"
    },
    "toolbar": {
      "searchPlaceholder": "Search by tracking number or order…",
      "allStatuses": "All Statuses",
      "allCarriers": "All Carriers"
    },
    "table": {
      "columns": {
        "trackingNumber": "TRACKING NUMBER",
        "carrier": "CARRIER",
        "orderRef": "ORDER",
        "status": "STATUS",
        "shipped": "SHIPPED",
        "estimatedDelivery": "ESTIMATED DELIVERY",
        "firstScan": "FIRST SCAN",
        "delivered": "DELIVERED",
        "sla": "SLA",
        "actions": "ACTIONS"
      },
      "status": {
        "delivered": "Delivered",
        "in_transit": "In Transit",
        "out_for_delivery": "Out for Delivery",
        "label_created": "Label Created",
        "pending_pickup": "Pending Pickup",
        "delayed": "Delayed",
        "exception": "Exception"
      },
      "deliveredPrefix": "Delivered",
      "delayDays": "+{{count}} days delayed",
      "slaDays": "{{count}}d",
      "empty": "No shipments match the active filter.",
      "notShipped": "—",
      "viewAction": "View details",
      "openExternal": "Open tracking link"
    },
    "pagination": {
      "total": "Total: {{count}}",
      "show": "Show",
      "prev": "Previous page",
      "next": "Next page"
    },
    "window": {
      "7d": "7 days",
      "30d": "30 days",
      "90d": "90 days",
      "aria": "SLA metrics window"
    },
    "actions": {
      "trackingUnavailable": "Tracking link unavailable: missing or invalid tracking number, or unsupported carrier.",
      "detailsUnavailable": "Order details unavailable: missing or invalid order ID."
    },
    "dashboardEmpty": "No data in this window"
  },
  "_vgBinding": "vg-binding: P9.2.D-11 P9.2.D-04 P9.2.D-01 P9.2.D-02 P9.2.D-12 — shipping i18n bundles moved from inline .ts to canonical shipping.json: methods/weightBands/history/margin [task-03]; trackRouting (TrackRoutingPage+ShipmentTable) + config (ConfigPage) [task-05]. vg-binding: P4.8.D-06 P4.8.D-22 (G-13) — rateTable2.navigation (CR-1 submenu labels) + rateTable2.bulk (CR-2 bulk-action labels) added across en/vi/fr [task-09]"
}
